import React from 'react';

const Blogs = () => {
    return (
        <div className='mx-auto bg-black min-h-[90vh] pt-20'>
            <div className='container'>
            <h1 className='text-3xl text-center mt-20 '>Comming Soon</h1>
            </div>
        </div>
    );
};

export default Blogs;